import React, { useState } from 'react';
import {
  Sparkles,
  Wine,
  Beer,
  Coffee,
  Flame,
  UtensilsCrossed,
  GlassWater,
} from 'lucide-react';

// ---------------------------------------------------------------------------
// Menu data (Saale Beach – Straßenaufsteller)
// ---------------------------------------------------------------------------

const cocktails = [
  { name: 'Aperol Spritz', desc: 'Aperol, Wasser, Secco, Orange', price: '6,80 €' },
  { name: 'Lillet', desc: 'Lillet, Wild Berry, Früchte', price: '6,80 €' },
  { name: 'Hugo', desc: 'Holunderblütensirup, Wasser, Secco, Minze, Limette', price: '6,80 €' },
  { name: 'Erdbeer Hugo', desc: 'Erdbeerpüree, Wasser, Secco, Minze, Limette', price: '6,80 €' },
  { name: 'Dejavu Peach', desc: 'Dejavu, Grapefruit, White Peach', price: '7,00 €' },
  { name: 'Campari Spritz', desc: 'Campari, Wasser, Secco, Orange', price: '7,00 €' },
  { name: 'Campari Orange', desc: 'Campari, O-Saft, Orange', price: '7,00 €' },
  { name: 'Frizzoli Spritz', desc: 'Frizzoli, Wasser, Zitrone', price: '8,00 €' },
  { name: 'Limoncello Spritz', desc: 'Secco, Limoncello, Zitrone, Wasser', price: '7,00 €' },
  { name: 'Gin Tonic', desc: 'Gin, Tonic Water, Zitrone', price: '8,00 €' },
  { name: 'Gin Wild Berry', desc: 'Gin, Wild Berry, gefrorene Beeren', price: '8,00 €' },
  { name: 'Pornstar Spritz', desc: 'Vanille, Maracuja, Vodka, Secco, Soda', price: '7,00 €' },
  { name: 'Ed von Schleck', desc: 'Erdbeere, Maracuja, Karamell, Vodka, Sahne', price: '7,80 €' },
  { name: 'Swimming Pool', desc: 'Blue Curacao, Kokos, Ananas, Rum, Sahne', price: '7,80 €' },
  { name: 'Moe Spezial', desc: 'Erdbeere, Cranberry, Johannisbeere, Vanille, Karamell, Sahne, Vodka', price: '7,80 €' },
  { name: 'Pina Colada', desc: 'Kokosnuss, Ananas, Bacardi, Sahne', price: '7,80 €' },
  { name: 'Strawberry Colada', desc: 'Erdbeere, Ananas, Sahne, Bacardi', price: '7,80 €' },
  { name: 'Tequila Sunrise', desc: 'Orange, Himbeere, Grenadine, Tequila', price: '7,80 €' },
  { name: 'Asbach Cola', desc: 'Asbach, Cola', price: '6,80 €' },
  { name: 'Jack Daniel Cola', desc: 'Jack Daniels, Cola', price: '6,80 €' },
  { name: 'Cuba Libre', desc: 'Havana, Cola, Limette', price: '7,00 €' },
  { name: 'Moscow Mule', desc: 'Limette, Ginger Beer, Vodka, Gurke', price: '7,50 €' },
  { name: 'Gin Mule', desc: 'Limette, Ginger Beer, Gin, Gurke', price: '8,00 €' },
  { name: 'Mojito', desc: 'Minze, Limette, brauner Zucker, Rum, Ginger Ale', price: '7,80 €' },
  { name: 'Mojito Erdbeere', desc: 'Minze, Limette, Rum, Wasser, Erdbeere', price: '7,80 €' },
  { name: 'Mojito Maracuja', desc: 'Minze, Limette, Wasser, Rum, Maracuja', price: '7,80 €' },
  { name: 'Mojito Yuzu', desc: 'Minze, Limette, Rum, Wasser, Yuzu', price: '8,00 €' },
  { name: 'Mojito Blaubeere', desc: 'Minze, Limette, Rum, Blaubeere', price: '7,80 €' },
  { name: 'Caipirinha', desc: 'Pitu, Limette, brauner Zucker', price: '7,80 €' },
  { name: 'Touch Down', desc: 'Orange, Maracuja, Zitrone, Grenadine, Vodka, Apricot', price: '7,80 €' },
  { name: 'Sex on the Beach', desc: 'Orange, Himbeere, Cranberry, Vodka, Apricot', price: '7,80 €' },
];

const cocktailsAlkoholfrei = [
  { name: 'Virgin Mojito', desc: 'Minze, Limette, brauner Zucker, Ginger Ale', price: '7,30 €' },
  { name: 'Virgin Mojito Erdbeere', desc: 'Minze, Limette, Erdbeere, Wasser', price: '7,30 €' },
  { name: 'Virgin Mojito Maracuja', desc: 'Minze, Limette, Maracuja, Wasser', price: '7,30 €' },
  { name: 'Virgin Mojito Yuzu', desc: 'Minze, Limette, Yuzu, Wasser', price: '7,50 €' },
  { name: 'Virgin Mojito Blaubeere', desc: 'Minze, Limette, Blaubeere, Wasser', price: '7,30 €' },
  { name: 'Virgin Hugo', desc: 'Holunderblütensirup, Wasser, Secco alk.frei, Limette, Minze', price: '6,80 €' },
  { name: 'Virgin Erdbeer Hugo', desc: 'Erdbeerpüree, Minze, Secco alk.frei, Wasser, Limette', price: '6,80 €' },
  { name: 'Virgin Orange Spritz', desc: 'Orange, Orangen Spritz, Wasser, Secco alk.frei', price: '6,80 €' },
  { name: 'Easy Driver', desc: 'Grenadine, Himbeere, Orange, Maracuja', price: '7,30 €' },
  { name: 'Coconut Kiss', desc: 'Kokosnuss, Grenadine, Ananas, Sahne, Blue Curacao', price: '7,30 €' },
  { name: 'Baby Colada', desc: 'Kokosnuss, Ananas, Sahne', price: '7,30 €' },
  { name: 'Mona Lisa', desc: 'Mango, Maracuja, Orange, Vanille, Sahne', price: '7,30 €' },
  { name: 'Virgin Ed von Schleck', desc: 'Erdbeere, Maracuja, Karamell, Sahne', price: '7,30 €' },
  { name: 'Virgin Moe Spezial', desc: 'Erdbeere, Vanille, Karamell, Johannisbeere, Cranberry, Sahne', price: '7,30 €' },
];

const softDrinks = [
  { name: 'Bad Brückenauer Wasser 0,5L', desc: 'still / medium', price: '3,00 €' },
  { name: 'Apfelschorle', price: '3,80 €' },
  { name: 'Johannisbeere', price: '3,80 €' },
  { name: 'Spezi Org. 0,33L', price: '3,50 €' },
  { name: 'Coca-Cola 0,33L', price: '3,50 €' },
  { name: 'Coca-Cola Zero 0,33L', price: '3,50 €' },
  { name: 'Trade Island Mango Passion 0,33L', price: '4,00 €' },
  { name: 'Trade Island Pfirsich 0,33L', price: '4,00 €' },
  { name: "Trade Island Mint 'n Lime 0,33L", price: '4,00 €' },
  { name: 'Bad Brambacher Orange 0,5L', price: '4,00 €' },
  { name: 'Bad Brambacher Zitrone 0,5L', price: '4,00 €' },
  { name: 'Bad Brambacher Pink Grapefruit 0,5L', price: '4,00 €' },
  { name: 'Bionade Holunder 0,33L', desc: 'enthält Koffein', price: '3,80 €' },
];

const bottledBeer = [
  { name: 'Mönchshof Radler Blutorange 0,5L', price: '4,00 €' },
  { name: 'Radler Blutorange alk.frei 0,5L', price: '4,00 €' },
  { name: 'Radler naturtrüb alk.frei 0,5L', price: '4,00 €' },
  { name: 'Pils naturtrüb alk.frei 0,5L', price: '4,00 €' },
  { name: 'Kapuziner Weizen alk.frei 0,5L', price: '4,30 €' },
  { name: 'Sternla Helles 0,5L', price: '4,00 €' },
];

const draughtBeer = [
  { name: 'Mönchshof Pils 0,5L', price: '4,00 €' },
  { name: 'Kapuziner Hefe Weizen 0,5L', price: '4,30 €' },
  { name: 'Mönchshof Radler 0,5L', price: '4,00 €' },
  { name: 'Cola Weizen 0,5L', price: '4,30 €' },
  { name: 'Russ 0,5L', price: '4,30 €' },
];

const beachWines = [
  { name: 'Silvaner, trocken', price: '5,50 € / 16,50 €' },
  { name: 'Weiß, feinfruchtig', price: '5,50 € / 16,50 €' },
  { name: 'Rosa, feinfruchtig', price: '5,50 € / 16,50 €' },
  { name: 'Rot, feinfruchtig', price: '5,50 € / 16,50 €' },
  { name: 'Secco, spritzig frisch', price: '5,50 € / 16,50 €' },
];

const warmDrinks = [
  { name: 'Cappuccino', price: '3,60 €' },
  { name: 'Latte Macchiato', price: '4,00 €' },
  { name: 'Tasse Kaffee', price: '3,30 €' },
  { name: 'Tee (verschiedene Sorten)', desc: 'enthält Koffein/Laktose (Milch)', price: '3,80 €' },
  { name: 'Kuchen', desc: 'an der Kasse erfragen', price: '4,00 €' },
];

const brennerin = [
  { name: 'Musterknabe – Williams', price: '4,00 €' },
  { name: 'Fräulein – Mirabelle', price: '4,00 €' },
  { name: 'Schamane – Ingwergeist', price: '4,00 €' },
  { name: 'Dickkopf – Haselnussgeist', price: '4,00 €' },
];

const klassikerSchnapps = [
  { name: 'Jägermeister', price: '3,00 €' },
  { name: 'Ficken', price: '3,00 €' },
  { name: 'Pfeffi', price: '2,50 €' },
  { name: 'Tequila Gold', price: '3,00 €' },
  { name: 'Tequila Silber', price: '3,00 €' },
];

const speisen = [
  { name: 'Kartoffel-Frischkäsetaschen mit Sour Cream', desc: '4 Stück', price: '5,50 €' },
  { name: 'Currywurst Pommes', price: '7,50 €' },
  { name: 'Bratwurst im Brötchen', price: '3,80 €' },
  { name: 'Flammkuchen Elsässer Art', desc: 'Schmand, Speck und Zwiebel', price: '8,50 €' },
  { name: 'Flammkuchen Griechische Art', desc: 'Schmand, Peperoni und Hirtenkäse', price: '8,50 €' },
  { name: 'Crunchpommes', price: '3,80 €' },
  { name: 'Pinsa Salami, Paprika, Käse', price: '5,00 €' },
  { name: 'Pinsa Tomate-Mozzarella, Pesto', price: '5,00 €' },
  { name: 'Käsewürfel, Weintrauben, Brezel', price: '6,00 €' },
  { name: 'Brezel', price: '2,00 €' },
  { name: 'Chicken Nuggets mit Pommes', price: '6,80 €' },
  { name: 'Bratwurst Pommes', price: '7,00 €' },
  { name: 'Panzerotti Mozzarella-Tomate', desc: '6 Mini-Teigtaschen mit Tomate-Mozzarella & Cocktailsoße', price: '6,00 €' },
  { name: 'Steinofen-Focaccia Caprese', desc: 'Hefeteig mit Mozzarella, Tomaten & Oliven', price: '10,00 €' },
  { name: 'Steinofen-Focaccia Salami', desc: 'Hefeteig mit Salami, Mozzarella, Käse & Paprika', price: '11,00 €' },
];

// ---------------------------------------------------------------------------
// Presentational helpers
// ---------------------------------------------------------------------------

const YELLOW = '#FFFF00';
const YELLOW_GLOW = '0 0 10px rgba(255,255,0,0.5)';

const MenuItem = ({ item }) => (
  <div
    className="flex justify-between items-start gap-4 py-3 border-b border-yellow-400/10 last:border-b-0"
    data-testid={`beach-menu-item-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
  >
    <div className="flex-1 min-w-0">
      <p
        className="text-white font-semibold"
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        {item.name}
      </p>
      {item.desc && (
        <p
          className="text-white/60 text-sm mt-0.5"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {item.desc}
        </p>
      )}
    </div>
    <p
      className="font-bold text-base md:text-lg whitespace-nowrap"
      style={{
        color: YELLOW,
        textShadow: YELLOW_GLOW,
        fontFamily: "'Playfair Display', serif",
      }}
    >
      {item.price}
    </p>
  </div>
);

const MenuGroup = ({ title, items }) => (
  <div className="mb-10 last:mb-0">
    <h3
      className="text-2xl md:text-3xl font-bold mb-4 tracking-wide"
      style={{
        color: YELLOW,
        textShadow: '0 0 15px rgba(255, 255, 0, 0.6)',
        fontFamily: "'Playfair Display', serif",
      }}
    >
      {title}
    </h3>
    <div>
      {items.map((item, idx) => (
        <MenuItem key={`${title}-${idx}`} item={item} />
      ))}
    </div>
  </div>
);

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------

const BeachMenuSection = () => {
  const [activeTab, setActiveTab] = useState('cocktails');

  const tabs = [
    { id: 'cocktails', label: 'Cocktails', icon: Sparkles },
    { id: 'bierwein', label: 'Bier & Wein', icon: Beer },
    { id: 'softdrinks', label: 'Softdrinks', icon: GlassWater },
    { id: 'warm', label: 'Warme Getränke', icon: Coffee },
    { id: 'schnapps', label: 'Schnäpse', icon: Flame },
    { id: 'speisen', label: 'Speisen', icon: UtensilsCrossed },
  ];

  return (
    <section
      id="beach-menu"
      className="py-20 px-4"
      style={{ background: 'linear-gradient(to bottom, #0A0015, #050010)' }}
      data-testid="beach-menu-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <Wine
            className="w-12 h-12 mx-auto mb-4"
            style={{ color: YELLOW, filter: 'drop-shadow(0 0 10px #FFFF00)' }}
          />
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Karte Saale Beach
          </h2>
          <div
            className="h-1 w-24 mx-auto rounded-full mb-6"
            style={{
              background: 'linear-gradient(to right, #FFFF00, #FFD700)',
              boxShadow: '0 0 15px #FFFF00',
            }}
          />
          <p
            className="text-white/70 text-lg"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Cocktails, Weine, Speisen und mehr – direkt am Ufer
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-10">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                data-testid={`beach-menu-tab-${tab.id}`}
                className="flex items-center gap-2 px-4 md:px-5 py-2.5 rounded-full text-sm md:text-base font-semibold transition-all duration-300"
                style={{
                  background: isActive
                    ? 'linear-gradient(135deg, #FFFF00 0%, #FFD700 100%)'
                    : 'rgba(255, 255, 0, 0.08)',
                  color: isActive ? '#0A0015' : 'white',
                  border: isActive
                    ? '1px solid #FFFF00'
                    : '1px solid rgba(255, 255, 0, 0.25)',
                  boxShadow: isActive
                    ? '0 0 20px rgba(255, 255, 0, 0.6)'
                    : 'none',
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        <div
          className="rounded-2xl p-6 md:p-10"
          style={{
            background:
              'linear-gradient(135deg, rgba(255, 255, 0, 0.04) 0%, rgba(0, 0, 0, 0.3) 100%)',
            border: '1px solid rgba(255, 255, 0, 0.2)',
            boxShadow: 'inset 0 0 30px rgba(255, 255, 0, 0.03)',
          }}
        >
          {activeTab === 'cocktails' && (
            <>
              <MenuGroup title="Cocktails" items={cocktails} />
              <MenuGroup title="Cocktails Alkoholfrei" items={cocktailsAlkoholfrei} />
              <p className="text-white/50 italic text-sm mt-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Wir benutzen Gin und Frizzoli von der Brennerin Franziska aus Wartmannsroth.
              </p>
            </>
          )}

          {activeTab === 'bierwein' && (
            <>
              <MenuGroup title="Bier – 0,5 L Flasche" items={bottledBeer} />
              <MenuGroup title="Bier – 0,5 L Fass" items={draughtBeer} />
              <MenuGroup title="Saale Beach Wein (0,25 L / 0,75 L)" items={beachWines} />
            </>
          )}

          {activeTab === 'softdrinks' && (
            <MenuGroup title="Soft Getränke" items={softDrinks} />
          )}

          {activeTab === 'warm' && (
            <MenuGroup title="Warme Getränke & Kuchen" items={warmDrinks} />
          )}

          {activeTab === 'schnapps' && (
            <>
              <MenuGroup title="Brennerin Franziska" items={brennerin} />
              <MenuGroup title="Klassiker" items={klassikerSchnapps} />
            </>
          )}

          {activeTab === 'speisen' && (
            <MenuGroup title="Speisen" items={speisen} />
          )}
        </div>
      </div>
    </section>
  );
};

export default BeachMenuSection;
